import React, { useState } from 'react';
import UserManagement from '../components/admin/UserManagement';
import EventManagement from '../components/admin/EventManagement';
import OrganizationManagement from '../components/admin/OrganizationManagement';
import CategoryManagement from '../components/admin/CategoryManagement';
import DashboardStats from '../components/admin/DashboardStats';
import Notification from '../components/admin/Notification';
import styles from './AdminDashboard.module.css';

type NotificationType = 'success' | 'error' | 'info';

interface AdminNotificationState {
  visible: boolean;
  type: NotificationType;
  message: string;
}

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'dashboard' | 'users' | 'events' | 'organizations' | 'categories'>('dashboard');
  const [notification, setNotification] = useState<AdminNotificationState>({
    visible: false,
    type: 'success',
    message: ''
  });

  // Fonction pour afficher une notification
  const showNotification = (message: string, type: NotificationType = 'success') => {
    setNotification({
      visible: true,
      type,
      message
    });
  };

  // Fonction pour masquer la notification
  const hideNotification = () => {
    setNotification(prev => ({
      ...prev,
      visible: false
    }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Tableau de bord d'administration</h1>
      </div>

      <div className={styles.tabs}>
        <button 
          className={`${styles.tab} ${activeTab === 'dashboard' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('dashboard')}
        >
          Statistiques
        </button>
        <button 
          className={`${styles.tab} ${activeTab === 'users' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('users')}
        >
          Utilisateurs
        </button>
        <button 
          className={`${styles.tab} ${activeTab === 'events' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('events')}
        >
          Événements
        </button>
        <button 
          className={`${styles.tab} ${activeTab === 'organizations' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('organizations')}
        >
          Organisations
        </button>
        <button 
          className={`${styles.tab} ${activeTab === 'categories' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('categories')}
        >
          Catégories
        </button>
      </div>

      {notification.visible && (
        <Notification 
          type={notification.type} 
          message={notification.message} 
          onClose={hideNotification} 
        />
      )}

      <div className={styles.content}>
        {activeTab === 'dashboard' && <DashboardStats />}
        {activeTab === 'users' && (
          <UserManagement 
            onSuccess={(message: string) => showNotification(message)} 
            onError={(message: string) => showNotification(message, 'error')} 
          />
        )}
        {activeTab === 'events' && (
          <EventManagement 
            onSuccess={(message: string) => showNotification(message)} 
            onError={(message: string) => showNotification(message, 'error')} 
          />
        )}
        {activeTab === 'organizations' && (
          <OrganizationManagement 
            onSuccess={(message: string) => showNotification(message)} 
            onError={(message: string) => showNotification(message, 'error')} 
          />
        )}
        {activeTab === 'categories' && (
          <CategoryManagement 
            onSuccess={(message: string) => showNotification(message)} 
            onError={(message: string) => showNotification(message, 'error')} 
          />
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
